import { render, staticRenderFns } from "./ForgotComplete.vue?vue&type=template&id=4c08d350"
import script from "./ForgotComplete.vue?vue&type=script&lang=js"
export * from "./ForgotComplete.vue?vue&type=script&lang=js"
import style0 from "./ForgotComplete.vue?vue&type=style&index=0&id=4c08d350&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports